import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'

const PlantSelection = ({
  personName,
  handleChangePlantName,
  plantList,
  errors,
  theme,
  MenuProps,
}) => {
  console.log('plantliast', plantList)

  const handleDelete = (valueToDelete) => (event) => {
    event.stopPropagation() // Prevent the Select from opening
    const newValue = personName.filter((_id) => _id !== valueToDelete)
    handleChangePlantName({
      target: { value: newValue },
    })
  }

  return (
    <Box sx={{ width: '100%' }}>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-name-label">Choose Plant</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple
          value={personName}
          onChange={handleChangePlantName}
          error={!!errors.personName}
          input={<OutlinedInput label="Choose Plant" />}
          MenuProps={MenuProps}
          renderValue={(selected) => (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5,
                maxWidth: '100%',
              }}
            >
              {selected.map((value) => {
                const plant = plantList.find((p) => p._id === value)
                return (
                  <Chip
                    key={value}
                    label={plant?.plantName}
                    onDelete={handleDelete(value)}
                    onMouseDown={(event) => {
                      event.stopPropagation() // Prevent Select from opening
                    }}
                    sx={{
                      margin: '2px',
                      backgroundColor: '#f0f0f0',
                      '& .MuiChip-deleteIcon': {
                        color: '#666',
                        '&:hover': {
                          color: '#333',
                        },
                      },
                    }}
                  />
                )
              })}
            </Box>
          )}
        >
          {plantList?.map((plant) => (
            <MenuItem
              key={plant?._id}
              value={plant?._id}
              style={{
                fontWeight:
                  personName.indexOf(plant?._id) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
              }}
            >
              {plant?.plantName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default PlantSelection
